export const getInitialsFromEmail = (email: string) => {
  return email?.split('@')[0]?.toUpperCase();
};
